module.exports = __webpack_public_path__ + "r-v3/img/ml_03_00.acdf053d.jpg";